var render = function render(){var _vm=this,_c=_vm._self._c;return _c('avs-button',{attrs:{"classB":"min-width-200 font-weight-bold","color":"primary","iconI":"mdi-domain","spantext":_vm.$t('nav.title.SelectCompany'),"text":"","to":{ name: 'SelectCompany' }},scopedSlots:_vm._u([{key:"name",fn:function(){return [_vm._v(" "+_vm._s(_vm.current))]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }